module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact-contact-attachment"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('lxm-panel', {
    attrs: {
      "rows": _vm.rows
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-487b4165", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-487b4165!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/Contact/Attachment.vue
// module id = 846
// module chunks = 0